import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nettleworth-frontend/src/components/ClientSideWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationProvider"] */ "/app/nettleworth-frontend/src/contexts/TranslationContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nettleworth-frontend/src/layouts/HomeLayout.js");
